import { GetCultureState, SharedState } from "../interfaces/shared.interface";

export const InitialSharedState: SharedState = {
    loading: false,
    error: null,
    success: null,
    message: null,
    userProfile: null,
}

export const InitialSharedStateGetCulture: GetCultureState  = {
    loading: false,
    error: null,
    success: null,
    message: null,
    culture: null,
}